module.exports = __webpack_public_path__ + "static/media/lightblades-installation-by-lucastswick-fractal-thumb-1.d4400a5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lightblades/lightblades-installation-by-lucastswick-fractal-thumb-1.jpg
// module id = 4271
// module chunks = 14